import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/(auth)/logout")({
  // `?expired=true` comes from lib/axios when the server refused the session:
  // log out locally only (T-234).
  validateSearch: z.object({
    expired: z.boolean().optional().catch(undefined),
  }),
  component: LogOut,
});

import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useAuthStore } from "@/stores/useAuthStore";

function LogOut() {
  const navigate = useNavigate();
  const { logout } = useAuthStore();
  const { expired } = Route.useSearch();
  useEffect(() => {
    logout({ endServerSession: !expired });
    setTimeout(() => {
      navigate({ to: "/login" });
    }, 0);
  }, [navigate, logout, expired]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Log out</p>
      </div>
    </div>
  );
}
